interface Notification {
  id: number;
  message: string;
  type: 'error' | 'success' | 'info';
}

const notifications = ref<Notification[]>([]);
let nextId = 0;

export const useNotification = () => {
  const add = (
    message: string,
    type: Notification['type'] = 'info',
    life = 4500,
  ) => {
    if (!import.meta.client) return;
    const id = nextId++;
    notifications.value.push({ id, message, type });
    if (life > 0) setTimeout(() => remove(id), life);
  };

  const remove = (id: number) => {
    const idx = notifications.value.findIndex((n) => n.id === id);
    if (idx !== -1) notifications.value.splice(idx, 1);
  };

  return { notifications, add, remove };
};
